import { useEffect } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { isEmpty } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import startupCurve from 'features/views/campaignSettings/startupCurve';

import WeekCard from './WeekCard';

export const WeekList = ({ campaignId }) => {
	const dispatch = useDispatch();

	const weeksIds = useSelector(startupCurve.selectors.getWeekIds);

	useEffect(() => {
		if (isEmpty(weeksIds)) {
			dispatch(startupCurve.actions.fetchWeeks(campaignId));
		}
		// eslint-disable-next-line
	}, [dispatch]);

	useEffect(
		() => () => {
			dispatch(startupCurve.actions.removeWeeks());
		},
		[dispatch],
	);

	return (
		<Paper sx={{ p: 3, borderRadius: 2 }}>
			<Stack spacing={2}>
				<SectionHeader text={getLabelMessage('startupCurve:week')} />
				<ComponentLoader fetchStorePath={startupCurve.constants.fetchState.get}>
					<Grid container>
						<Grid size={12}>
							<Grid container spacing={2}>
								{weeksIds &&
									weeksIds.map((id, index) => {
										return (
											<Grid key={id} size={4}>
												<WeekCard weekId={id} weekPosition={index + 1} />
											</Grid>
										);
									})}
							</Grid>
						</Grid>
					</Grid>
				</ComponentLoader>
			</Stack>
		</Paper>
	);
};

WeekList.propTypes = {
	campaignId: PropTypes.number,
};

export default WeekList;
